var Presets;
(function (Presets) {
    Presets["TODAY"] = "today";
    Presets["YESTERDAY"] = "yesterday";
    Presets["LAST_7_DAYS"] = "last-7-days";
    Presets["LAST_30_DAYS"] = "last-30-days";
    Presets["THIS_MONTH"] = "this-month";
    Presets["LAST_MONTH"] = "last-month";
    Presets["THIS_YEAR"] = "this-year";
    Presets["LAST_3_MONTHS"] = "last-3-months";
    Presets["LAST_6_MONTHS"] = "last-6-months";
    Presets["LAST_12_MONTHS"] = "last-12-months";
    Presets["LAST_YEAR"] = "last-year";
})(Presets || (Presets = {}));
export { Presets };
